import { Button } from "components/DesignSystem/Button/Button";
import { LabelledValue } from "components/MobileListRow/LabelledValue";
import { Cell, flexRender, Row } from "react-table-8.10.7";
import { CreditNote } from "store/apis/creditNotes";

type MobileCreditNoteRowProps = {
  row: Row<CreditNote>;
  onRowClick: (creditNoteId: string) => void;
};

// Column ids set on the column helpers in CreditNotes.
const CREDIT_NOTE_COLUMN_ID = {
  NOTE_ID: "NOTE_ID",
  DATE: "DATE",
  DESCRIPTION: "DESCRIPTION",
  AMOUNT: "AMOUNT",
  STATUS: "STATUS",
  ACTIONS: "ACTIONS",
} as const;

const renderCell = (cell?: Cell<CreditNote, unknown>) =>
  cell ? flexRender(cell.column.columnDef.cell, cell.getContext()) : null;

export const MobileCreditNoteRow = ({
  row,
  onRowClick,
}: MobileCreditNoteRowProps) => {
  const cellsById = Object.fromEntries(
    row.getVisibleCells().map((cell) => [cell.column.id, cell])
  );

  const handleClick = () => onRowClick(row.original.uuid);

  return (
    <div className="t-flex t-flex-col t-gap-3 t-border-0 t-border-b t-border-solid t-border-neutral-0 t-py-3">
      <div className="t-flex t-items-center t-gap-2">
        <div className="t-min-w-0 t-flex-1 t-text-subtext t-text-text-100">
          {renderCell(cellsById[CREDIT_NOTE_COLUMN_ID.NOTE_ID])}
        </div>
        <div className="t-shrink-0">
          {renderCell(cellsById[CREDIT_NOTE_COLUMN_ID.ACTIONS])}
        </div>
      </div>

      <Button
        type="button"
        customType="ghost"
        onClick={handleClick}
        className="!t-h-auto !t-p-0 !t-whitespace-normal t-text-left [&>div]:t-w-full [&>div]:t-justify-start [&>div>div]:t-w-full [&>div>div]:t-justify-start"
      >
        <div className="t-flex t-w-full t-flex-col t-gap-3">
          {row.original.description && (
            <div className="t-min-w-0 t-text-text-60">
              {renderCell(cellsById[CREDIT_NOTE_COLUMN_ID.DESCRIPTION])}
            </div>
          )}

          <div className="t-grid t-grid-cols-3 t-gap-2">
            <LabelledValue label="Date">
              {renderCell(cellsById[CREDIT_NOTE_COLUMN_ID.DATE])}
            </LabelledValue>
            <LabelledValue label="Credit amount">
              {renderCell(cellsById[CREDIT_NOTE_COLUMN_ID.AMOUNT])}
            </LabelledValue>
            <LabelledValue label="Status">
              {renderCell(cellsById[CREDIT_NOTE_COLUMN_ID.STATUS])}
            </LabelledValue>
          </div>
        </div>
      </Button>
    </div>
  );
};
